import { Outlet, useParams } from "react-router";
import { createContext, useContext, useEffect, useState } from "react";
// import { IDisributorInfoExtend, IPartnerExtend } from "./DistributorDetail";
import { apiRemote } from "@/api/wp-api";
import { useAlert } from "@/contexts/AlertContext";
import { decodeId } from "@/utils/decodeId";
import { useCustomBreadcrumb } from "@/contexts/CustomBreadcrumb";
import { IUserBadgeExtend } from "./MyBadge";

export interface MyBadgeContextType {
    getUserBadge: (page: any, pageSize: any) => Promise<any>;
}
const MyBadgeContext=createContext<MyBadgeContextType>({} as any);

export function MyBadgeLayout(){
    const { id } = useParams<{ id: string }>(); 
    const alert=useAlert();

    const getUserBadge=(page: any, pageSize: any)=>{
        return apiRemote.getDashboardUserBadge(page, pageSize).catch((err: any) => {
            alert.error(err.message);
            return {} as IUserBadgeExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    useEffect(()=>{

    },[id]);
    return (
        <MyBadgeContext.Provider value={{getUserBadge}}>
            <Outlet />
        </MyBadgeContext.Provider>
    )
}

export function useMyBadgeContext(){
    return useContext(MyBadgeContext);
}